/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    StationOrLocationItem,
    StationOrLocationItemFromJSON,
    StationOrLocationItemFromJSONTyped,
    StationOrLocationItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupplierLocationMappingListQuery
 */
export interface SupplierLocationMappingListQuery {
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof SupplierLocationMappingListQuery
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof SupplierLocationMappingListQuery
     */
    supplierValue?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierLocationMappingListQuery
     */
    includeDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierLocationMappingListQuery
     */
    includeDisabled?: boolean;
    /**
     * 
     * @type {StationOrLocationItem}
     * @memberof SupplierLocationMappingListQuery
     */
    oneAirLocation?: StationOrLocationItem;
    /**
     * 
     * @type {number}
     * @memberof SupplierLocationMappingListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SupplierLocationMappingListQuery
     */
    limit?: number | null;
}

export function SupplierLocationMappingListQueryFromJSON(json: any): SupplierLocationMappingListQuery {
    return SupplierLocationMappingListQueryFromJSONTyped(json, false);
}

export function SupplierLocationMappingListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierLocationMappingListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'supplierValue': !exists(json, 'supplierValue') ? undefined : json['supplierValue'],
        'includeDeleted': !exists(json, 'includeDeleted') ? undefined : json['includeDeleted'],
        'includeDisabled': !exists(json, 'includeDisabled') ? undefined : json['includeDisabled'],
        'oneAirLocation': !exists(json, 'oneAirLocation') ? undefined : StationOrLocationItemFromJSON(json['oneAirLocation']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function SupplierLocationMappingListQueryToJSON(value?: SupplierLocationMappingListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'supplierValue': value.supplierValue,
        'includeDeleted': value.includeDeleted,
        'includeDisabled': value.includeDisabled,
        'oneAirLocation': StationOrLocationItemToJSON(value.oneAirLocation),
        'offset': value.offset,
        'limit': value.limit,
    };
}


